import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import dummyProfile from "../../assets/dummy-profile-photo.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userLogin } from "../../redux/action";
import { useTranslation } from "../../languages";
import { useContext } from "react";


const Header = ({ title, onLogout, profilePicture }) => {
  const navigateTo = useNavigate();

  //user redux
  const user_Redux = useSelector((s) => s?.user || {});
  const { t } = useTranslation();

  const fireUserLogoutEvent = () => {
    return window?.dispatchEvent(new Event("user-logout"));
  };
  return (
    <div className="py-3 d-flex align-items-center justify-content-between mb-2">
      <h4 className="f-7 color-primary-black-2 m-0">{t(title)}</h4>
      <UncontrolledDropdown>
        <DropdownToggle className="bg-transparent d-flex align-items-center gap-2 border-transparent p-0">
          <img
            src={profilePicture ?? user_Redux?.profilePicture ?? dummyProfile}
            height={50}
            width={50}
            className="avatar"
            alt="user-avatar"
            
          />
        
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => navigateTo("/profile")}>
            {t("profile")}
          </DropdownItem>
          <DropdownItem onClick={() => navigateTo('/profile?open="settings"')}>
            {t("settings")}
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              if (typeof onLogout === "function") {
                onLogout();
              } 
              else {fireUserLogoutEvent()}
            }}
          >
            {t("logout")}
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default Header;
